import DashboardLayout from '@Dashboard/Layout/DashboardLayout';
import TimeRangeSelector from '@Dashboard/TimeRangeSelector';
import { useDashboardDaysStore } from '@Models/useDashboardDaysModel';
import { useTranslation } from 'react-i18next';
import QuishingDetections from './QuishingDetections';
import QuishingTop5Senders from './QuishingTop5Senders';
import QuishingTop5Recipients from './QuishingTop5Recipients';
import QuishingContentType from './QuishingContentType';
import { DashboardPeriod } from '@Types/dashboard';
import { useExpandSection } from '../useExpandSection';

const Quishing = () => {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'quishing',
      period: daysModel.days.DashboardQuishing as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.quishing')}
      titleBar={<TimeRangeSelector widgetId="DashboardQuishing" />}
      barColor="#A04242"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <QuishingDetections
        data={data}
        day={daysModel.days['DashboardQuishing']}
      ></QuishingDetections>
      <QuishingTop5Senders
        data={data}
        day={daysModel.days['DashboardQuishing']}
      ></QuishingTop5Senders>
      <QuishingTop5Recipients
        data={data}
        day={daysModel.days['DashboardQuishing']}
      ></QuishingTop5Recipients>
      <QuishingContentType
        data={data}
        day={daysModel.days['DashboardQuishing']}
      ></QuishingContentType>
    </DashboardLayout>
  );
};

export default Quishing;
